import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../theme/constants';

export const BecomeAClientWrapperMobile = styled.div`
   display: none;
   box-sizing: border-box;
   width: 300px;
   height: 250px;
   justify-content: initial;
   z-index: 0;
   position: relative;
   z-index: 0;
   flex-direction: column;
   padding: 25px 30px;

   @media only screen and (max-width: 1200px) {
      display: flex;
   }
`;

export const BecomeAClientHeaderMobile = styled.div`
   font-size: 20px;
   color: ${COLOR.WHITE};
   ${TYPOGRAPHY.BLACK}
`;

export const BecomeAClientSubmitMobile = styled.div`
   flex-grow: 1;
   display: flex;
   align-items: center;
`;

export const BecomeAClientButtonMobile = styled.a`
   padding: 14px 0;
   width: 100%;
   font-size: 12px;
   background-color: ${COLOR.BLUE};
   border-radius: 25px;
   color: ${COLOR.WHITE};
   font-size: 14px;
   ${TYPOGRAPHY.BLACK}
   text-align: center;
   text-decoration: none;

   &:hover {
      background-color: ${COLOR.BLUE_HOVER};
   }
`;
